import { CustomState } from "@bToC/Store/Reducers";

export function getStatementLines(state: CustomState) {
    return state.statementLinesReducer;
}

